<template>
<svg viewBox="0 0 20 20" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-fill-selector`]" width="1em" height="1em" v-bind="$attrs"><path d="M12.4162 9.18554L16.6511 13.4205C17.5433 14.3126 17.5433 15.759 16.6511 16.6511C15.759 17.5433 14.3126 17.5433 13.4205 16.6511L9.18554 12.4162L6.2976 15.3051C5.6968 15.9061 4.6683 15.5868 4.51353 14.7512L2.52177 3.99766C2.36 3.12424 3.12424 2.36 3.99766 2.52177L14.7512 4.51353C15.5868 4.6683 15.9061 5.6968 15.3051 6.2976L12.4162 9.18554Z"/></svg>
</template>
<script>

export default {
  name: 'IconFillSelector',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
